import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import moment from "moment";
import axios from "axios";
import "./calendar.css";
import { connect } from "react-redux";
import {
  priceFormatter,
  CURRENCY_SYMBOLS,
} from "../../../helpers/general.helper";

function MyCalendar(props) {
  const [priceList, setPriceList] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (data) => {
    props.onChange(data);
  };

  useEffect(() => {
    if (props.query && props.query != "") {
      if (props.showTwoMonths) {
        //  let endDate=  moment().add(1,'month').endOf('month')
        //  getPrice(moment(),endDate)

        getReturnPrice();
      } else getPrice(props.value ? moment(props.value) : moment());
    }
  }, [props.query]);

  const getPrice = async (start = moment(), end = null) => {
    setLoading(true);
    let startDate = moment(start).startOf("month");
    let endDate = moment(start).endOf("month");

    if (end) endDate = end;
    if (props.query) {
      let newQuery = `${props.query}&date_from=${startDate.format(
        "DD/MM/yyyy"
      )}&&date_to=${endDate.format("DD/MM/yyyy")}&one_per_date=1&sort=price`;

      let response2 = await axios.get(newQuery);
      if (response2 && response2.data && response2.data.data) {
        let result = { ...priceList };
        let data = response2.data.data.data;
        if (data) {
          let sortedArr = data.sort(
            (a, b) => new Date(a.local_departure) - new Date(b.local_departure)
          );
          let checkedData = data.map((it) => ({
            date: formatDate(it.local_departure),
            price: it.price,
          }));
          let currency = localStorage.getItem("selectedCurrency");
          for (let i = 0; i < sortedArr.length; i++) {
            let sorted = sortedArr[i];
            result[formatDate(sorted.local_departure)] = `${
              CURRENCY_SYMBOLS[currency] ? CURRENCY_SYMBOLS[currency] : currency
            }${priceFormatter(sorted.price, 2)}`;
          }
        }
        setPriceList(result);
        setLoading(false);
      }
    }
  };

  const getReturnPrice = async (
    start = moment(),
    returnFrom = moment().add(1, "day"),
    returnTo = moment().add(1, "month").endOf("month")
  ) => {
    setLoading(true);
    if (props.query) {
      let newQuery = `${props.query}&date_from=${start.format(
        "DD/MM/yyyy"
      )}&return_from=${returnFrom.format(
        "DD/MM/yyyy"
      )}&return_to=${returnTo.format("DD/MM/yyyy")}&one_per_date=1&sort=price`;

      let response2 = await axios.get(newQuery);
      if (response2 && response2.data && response2.data.data) {
        let result = { ...priceList };
        let data = response2.data.data.data;
        if (data) {
          let currency = props.currency;

          for (let i = 0; i < data.length; i++) {
            let it = data[i];
            if (it.route && it.route.length >= 2) {
              let returnRoute = it.route.find(
                (route) => route.flyFrom == it.flyTo
              );
              if (returnRoute) {
                let departure_date = returnRoute.local_departure;
                result[formatDate(departure_date)] = `${
                  CURRENCY_SYMBOLS[currency]
                    ? CURRENCY_SYMBOLS[currency]
                    : currency
                }${priceFormatter(it.price, 2)}`;
              }
            }
          }

          setPriceList(result);
          setLoading(false);
        }
      }
    }
  };

  const formatDate = (dt) => {
    let dateStr = String(dt).slice(0, 10);
    return dateStr;
  };

  return (
    <div>
      <Calendar
        onChange={handleChange}
        value={props.value}
        locale={"en-US"}
        selectRange={props.showRange}
        showDoubleView={props.showTwoMonths}
        showNeighboringMonth={false}
        onActiveStartDateChange={({ action, activeStartDate, value, view }) => {
          // if (view === "month"&&action=="next" && moment(activeStartDate).isSameOrAfter(new Date())) {
          if (view === "month" && (action == "next" || action == "prev")) {
            if (props.showTwoMonths) {
              let endDate = moment(activeStartDate)
                .add(1, "month")
                .endOf("month");
              let returnfromDate = moment(props.selectedDate).add(1, "day");
              getReturnPrice(
                moment(props.selectedDate),
                returnfromDate,
                endDate
              );
            } else getPrice(moment(activeStartDate));
          }
        }}
        minDate={props.minDate}
        disabpePast={true}
        defaultActiveStartDate={
          props.showTwoMonths ? props.value[0] : props.value
        }
        tileContent={({ activeStartDate, date, view }) => {
          if (props.query && props.query != "") {
            let _date = date;

            let formatDate = moment(date).format("YYYY-MM-DD");

            if (priceList[formatDate])
              return (
                <p
                  style={{
                    color: "black",
                    fontSize: "10px",
                    marginBottom: "0px",
                  }}
                >
                  {priceList[formatDate]}
                </p>
              );

            if (loading)
              return (
                <>
                  <p
                    style={{
                      color: "white",
                      fontSize: "10px",
                      marginBottom: "0px",
                      filter: "blur(3px)",
                    }}
                  >
                    000
                  </p>
                </>
              );
          }
        }}
      />
    </div>
  );
}
// export default MyCalendar;

const mapStateWithProps = (state) => ({
  currency: state.flight.currency ? state.flight.currency : "",
});

export default React.memo(connect(mapStateWithProps)(MyCalendar));
MyCalendar.defaultProps = {
  query: "",
  defaultDate: new Date(),
  minDate: new Date(),
  showTwoMonths: false,
  showRange: false,
};
